export const PLANT_DETAIL = 'plantDetail';
export const PLANTS = 'plants';
export const USER_DETAIL = 'userDetail';
export const USERS = 'users';
export const NOT_FOUND = 'not-found';
export const TRANSPORT_TYPES = 'transportTypes';
export const TRANSPORT_TYPE_DETAIL = 'transportTypeDetail';
export const DASHBOARD_STATUS_CONFIG = 'dashboardStatusConfig';
export const NOTIFICATION_CONFIG = 'notificationConfig';
